import React, { CSSProperties, ReactNode } from 'react';
import styled from 'styled-components';
import {
  useAnalyticsPost,
  NarvarClickTypes,
  NarvarClickSubTypes,
  NarvarEventComponents,
  NarvarEventTypes,
} from '@narvar/nth-hook-context-analytics';
import { useCustomComponentStateContext } from '../../hooks/useCustomComponentState';
import { MappedItem } from '../../hooks/useProductRecsApi';

const ProductTileContainer = styled.div<{ s?: CSSProperties }>(({ s }) => ({
  margin: '0 auto',
  ...s,
}));

export interface ProductTileProps {
  children?: ReactNode;
  productInfo: MappedItem;
  sliderIndex: number;
}

function ProductTile({ children, productInfo, sliderIndex }: ProductTileProps) {
  const { state } = useCustomComponentStateContext();
  const logEvent = useAnalyticsPost();

  const retailerTheme = state?.queryData?.retailerTheme;

  const productrecsreccontainerNoneNone: unknown =
    retailerTheme?.productrecsreccontainerNoneNone || {};

  const { maxWidth: maxContainerWidth = '9.5' } =
    (retailerTheme?.productrecsrecimageNoneNone as {
      maxWidth?: string;
    }) || {};

  const tileUrl: unknown = productInfo?.URL || '';
  return (
    <ProductTileContainer
      s={{
        ...(productrecsreccontainerNoneNone &&
        typeof productrecsreccontainerNoneNone === 'object'
          ? productrecsreccontainerNoneNone
          : {}),
        width: `${maxContainerWidth}rem`,
      }}
    >
      {tileUrl && typeof tileUrl === 'string' ? (
        <a
          href={tileUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() =>
            logEvent({
              clickCategory: NarvarClickSubTypes.PRODUCT_RECOMMENDATIONS,
              clickLinkDestinationUrl: tileUrl,
              clickLinkLabel: tileUrl,
              clickProductRecItemIndex: sliderIndex,
              clickProductRecItemName:
                typeof productInfo?.NAME === 'string' ? productInfo?.NAME : '',
              clickSubType: NarvarClickSubTypes.PRODUCT_RECOMMENDATIONS,
              clickType: NarvarClickTypes.OUTGOING,
              eventComponent: NarvarEventComponents.NTH_BLOCK_CUSTOM_COMPONENT,
              eventFeature: NarvarEventComponents.NTH_BLOCK_CUSTOM_COMPONENT,
              eventType: NarvarEventTypes.CLICK,
              feature: 'productRecommendations',
              pageComponent: NarvarEventComponents.NTH_BLOCK_CUSTOM_COMPONENT,
            })
          }
          style={{
            textDecoration: 'none',
          }}
        >
          {children}
        </a>
      ) : (
        <div>{children}</div>
      )}
    </ProductTileContainer>
  );
}

export default ProductTile;
